import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
// import OpenInNewIcon from "@material-ui/icons/OpenInNew";

import useStyles from "./styles";

const DialogMessage = ({
  isOpen = false,
  subject,
  message,
  closeReadingNotificationDialog,
  children,
  setNoCache,
  maxWidth,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={!!isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={maxWidth}
      {...props}
    >
      <DialogTitle id="alert-dialog-title">{subject}</DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        {message && <DialogContentText id="alert-dialog-description" dangerouslySetInnerHTML={{ __html: message }} />}
        {children && (
          <DialogContentText root="div" id="alert-dialog-description">
            {children}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
        <Button
          variant="contained"
          size="large"
          color="primary"
          data-cy="confirm-dialog-ok"
          id="confirm-dialog-ok"
          classes={{ root: classes.closeModal }}
          onClick={() => {
            closeReadingNotificationDialog && closeReadingNotificationDialog();
            setNoCache && setNoCache();
          }}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogMessage;
